import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class CoinEventsService {

    constructor(private http: HttpRequestService) {
    }

    //transfer param to execute search action
    gets(parameters:any) {
        return this.http.get(`coinevents`,
            parameters)
            .map(res => {
                return res.json();
            })
    }

    //transfer coin events id to execute edit action
    get(coinEventsId) {
        return this.http.get(`coinevents/coin?id=${coinEventsId}`)
            .map(res => {
                return res.json();
            })
    }

    //transfer model to execute add action
    add(model: any) {
        return this.http.post(`coinevents`, model)
            .map(res => {
                return res.json();
            });
    }

    //transfer model to execute active action
    active(model: any) {
        return this.http.put(`coinevents/active`, model)
            .map(res => {
                return res.json();
            });
    }

    //transfer model to execute edit action
    edit(model: any) {
        return this.http.put(`coinevents`, model)
            .map(res => {
                return res.json();
            });
    }

    //transfer id to execute delete action
    delete(id: string) {
        return this.http.delete(`coinevents?id=${id}`)
            .map(res => {
                return res.json();
            });
    }

    getListCoin() : Observable<any[]>{
        return this.http.get(`coinevents/listCoin`)
            .map(res => {
                return res.json();
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/coinevents.service.ts